export type InvoiceDetails = {
  companyName: string;
  address: string;
  taxId?: string;
};

export type ValidateInvoiceDetailsResult = { status: ValidateInvoiceDetailsStatus.OK } | { status: ValidateInvoiceDetailsStatus.ERROR, message?: string }

export enum ValidateInvoiceDetailsStatus {
  OK = 'ok',
  ERROR = 'error',
};